import React from 'react'

type ActionButton = {
  label: string
  icon?: string
  onClick?: () => void
  primary?: boolean
  href?: string
}

type Props = {
  title: string
  subtitle?: string
  actions?: ActionButton[]
}

/**
 * Azure Curator page header component.
 * Replaces the hidden Metronic PageTitle/Toolbar with the editorial modernist
 * header pattern: large Manrope title + subtitle + action buttons.
 */
const AzPageHeader: React.FC<Props> = ({title, subtitle, actions = []}) => {
  return (
    <section
      className='az-page-header'
      style={{
        marginBottom: '2.5rem',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'flex-end',
        flexWrap: 'wrap',
        gap: '1rem',
      }}
    >
      <div>
        <h2
          style={{
            fontFamily: 'Manrope, sans-serif',
            fontSize: '2.25rem',
            fontWeight: 800,
            color: '#00347f',
            letterSpacing: '-0.02em',
            margin: 0,
            lineHeight: 1.1,
          }}
        >
          {title}
        </h2>
        {subtitle && (
          <p style={{color: '#434652', margin: '0.25rem 0 0', fontSize: '1rem', fontWeight: 400}}>
            {subtitle}
          </p>
        )}
      </div>
      {actions.length > 0 && (
        <div style={{display: 'flex', gap: '0.75rem', flexShrink: 0}}>
          {actions.map((action, i) =>
            action.primary ? (
              <button
                key={i}
                onClick={action.onClick}
                style={{
                  padding: '0.625rem 1.25rem',
                  background: 'linear-gradient(135deg, #00347f 0%, #1a4ba1 100%)',
                  color: 'white',
                  border: 'none',
                  borderRadius: '0.75rem',
                  fontSize: '0.875rem',
                  fontWeight: 700,
                  cursor: 'pointer',
                  display: 'flex',
                  alignItems: 'center',
                  gap: '0.5rem',
                }}
              >
                {action.icon && (
                  <span className='material-symbols-outlined' style={{fontSize: '18px'}}>
                    {action.icon}
                  </span>
                )}
                {action.label}
              </button>
            ) : (
              <button
                key={i}
                onClick={action.onClick}
                style={{
                  padding: '0.625rem 1.25rem',
                  backgroundColor: 'white',
                  color: '#00347f',
                  border: '1px solid rgba(195, 198, 212, 0.3)',
                  borderRadius: '0.75rem',
                  fontSize: '0.875rem',
                  fontWeight: 600,
                  cursor: 'pointer',
                  display: 'flex',
                  alignItems: 'center',
                  gap: '0.5rem',
                }}
              >
                {action.icon && (
                  <span className='material-symbols-outlined' style={{fontSize: '18px'}}>
                    {action.icon}
                  </span>
                )}
                {action.label}
              </button>
            )
          )}
        </div>
      )}
    </section>
  )
}

export {AzPageHeader}
